<template>
    <div class="pop_overlay_black" v-if="isShow" style="z-index:9999">
        <div class="pop_wrap pop_noti">
            <div v-if="isLoading" class="loading_bg transparent" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <button  class="pop_noti_close" :disabled="isLoading" v-if="usingCloseButton" @click="_action_Close">
                <v-icon>mdi-close</v-icon>
            </button>
            <div class="pop_noti_danger_wrap" v-if="usingAlertTag">
                <span class="pop_noti_danger"><v-icon class="red_txt">mdi-alert-circle</v-icon> {{ $t('common.label_danger_alert') }}</span>
            </div>
            <div class="cont">
                <pre><b>{{ $t('popup_user_reservation.alert_send_notification_title') }}</b></pre>
                <pre>{{ alertMessage }}</pre>
            </div>
            <div class="pop_noti_btn_wrap">
                <button class="btn btn_s btn_gray" :disabled="isLoading" @click="_action_Left">
                    {{ lButtonTitle }}
                </button>
                <button class="btn btn_s btn_blue" ref="rightButton" :disabled="isLoading" @click="_action_Right" >
                    {{ rButtonTitle }}
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import AlertPopup from './AlertPopup.vue'
export default {
    mixins: [AlertPopup],
    data() {
        return {
            type: 'AlertSendPush'
        }
    },
    watch: {
        isShow: {
            handler: function (newValue) {
                if (newValue == true) {
                    this.$nextTick( () => {
                        this.$refs?.rightButton?.focus()
                    })
                }
            }
        }
    },
    computed: {
        alertMessage: function() {
            if (this.params?.isJoined == true) {
                return this.$t('popup_user_reservation.alert_send_notification_afterdoc_app_description')
            }
            return this.$t('popup_user_reservation.alert_send_notification_description')
        }
    }
}
</script>